import { Component, OnInit } from '@angular/core';
import { AuthService, AvailabilityService, CustomerProductPrice, GungFlowService, PriceService, Product, ProductExportTableComponent } from 'gung-standard';
import { first, forkJoin, of, switchMap } from 'rxjs';

interface ProductTableRow {
  id: string;
  name: string;
  packageSize: number;
  product?: Product;
  price?: CustomerProductPrice;
  replacementId: string;
}

@Component({
  selector: 'cult-product-export-table',
  templateUrl: './cult-product-export-table.component.html',
  styleUrl: './cult-product-export-table.component.scss',
  standalone: false
})
export class CultProductExportTableComponent extends ProductExportTableComponent implements OnInit {
  isReturnFlow: boolean = false;

  constructor(
    protected priceService: PriceService,
    protected availabilityService: AvailabilityService,
    protected authService: AuthService,
    protected gungFlowService: GungFlowService
  ) {
    super(
      priceService,
      availabilityService,
      authService
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.gungFlowService.getSelectedFlow().pipe(first()).subscribe(flow => {
      this.isReturnFlow = !!flow.isReturnOrder;
    });
  }

  protected subscribeToProducts() {
    const newIds = this.data.map(p => p.id).filter(id => !Object.keys(this.keyedMapData).includes(id));
    if (newIds.length === 0) {
      this.readMappedDataFromCache();
      return;
    }
    const subscription = this.authService
      .getCurrentUser()
      .pipe(
        first(),
        switchMap(user => forkJoin([
          of(this.data),
          this.priceService.getCurrentCustomerPrices(newIds).pipe(first())
        ]))
      )
      .subscribe(data => {
        const productData = data[0];
        const priceData = data[1];

        this.keyedMapData = {
          ...this.keyedMapData,
          ...newIds.reduce((acc, curr) => {
            const product = productData.filter(p => p.id === curr)[0];
            if (!product) {
              throw new Error('No product found');
            }

            const price = priceData.filter(p => p.productId === curr)?.[0];

            const item: ProductTableRow = this.mapItem(curr, product, price);
            return {
              ...acc,
              [curr]: item
            };
          }, {})
        };
        this.readMappedDataFromCache();
      });
    this.subscriptions.push(subscription);
  }

  mapItem(id: string, product: Product, price?: CustomerProductPrice): ProductTableRow {
    return {
      id,
      name: product.name,
      product,
      price,
      packageSize: product?.extra?.ar?.artfsgforp,
      replacementId: product?.extra?.ar?.q_gung_filter
    };
  }
}

